import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { emailValidator } from 'src/app/theme/utils/app-validators';
import { ApiService } from 'src/app/shared/services/api.service';
import { NotificationService } from 'src/app/shared/services/notification.service';
import { displayErrorMessage } from 'src/app/theme/utils/util-functions';
import { Router } from '@angular/router';
import { SubscriptionService } from 'src/app/shared/services/subscription.service';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit {

  forgotPasswordForm: FormGroup;

  constructor(
    private formBuilder: FormBuilder,
    private apiService: ApiService,
    private notification: NotificationService,
    private router: Router
  ) { }

  ngOnInit() {

    this.forgotPasswordForm = this.formBuilder.group({
      'email_id': ['', Validators.compose([Validators.required, emailValidator])],
    });
    
  }

  onForgotPasswordFormFormSubmit() {
    if(this.forgotPasswordForm.valid) {
      this.apiService.forgotPassword(this.forgotPasswordForm.value.email_id.toLowerCase()).subscribe(data => {
        if(data['response'].status === 6 || data['response'].status === 5) {
          this.notification.warning(data['response'].message, 5000);
        }else if(data['response'].status === 7) {
          this.notification.error(data['response'].message), 5000;
        }else if(data['response'].status === 1) {
          var queryParams = this.router.url.includes('cart') ? {queryParams:{'redirectURL': this.router.url}} : {};
          this.router.navigate(['/sign-in'], queryParams);
          this.notification.success(data['response'].message, 5000);
        }else if(data['response'].status === 0) {
          this.notification.error(data['response'].message, 5000);
        }else if(data['response'].status === 2 || data['response'].status === 3) {
          displayErrorMessage({
            notification: this.notification, 
            response: data['response'], 
            formControl: this.forgotPasswordForm.controls
          });
        }
      }, err => {
        console.log(err)
      });
    }
  }

}
